import { Link } from 'gatsby';
import React from 'react';

import { ReactComponent as ChevronRightIcon } from '/src/images/icons/chevron-right.svg';

import { dateRangeMedWithZoneOffset } from '../../helpers/dates';
import { OccationOfferCard } from '../../helpers/list-page/interfaces/list-card.interface';
import { ILibraryMeetingPlaceDictionary } from '../../queries/fragments/libraryMeetingPlaceDictionary';
import { CardLogo } from './card-logo';

interface CardOfferProps {
  card: OccationOfferCard;
  cardIndex: number;
  dictionary?: ILibraryMeetingPlaceDictionary;
}

export const CardOffer = ({ card, cardIndex, dictionary }: CardOfferProps) => {
  return (
    <Link
      to={card.slug}
      className={`group flex animate-fadeIn flex-col rounded-xl bg-background-primary-light opacity-0 transition-opacity duration-200 ease-in-out hover:bg-background-secondary focus:outline focus:outline-3 focus:outline-offset-3 focus:outline-text-light animation-delay-${cardIndex}`}
    >
      {card?.logo ? (
        <CardLogo
          card={card}
          className="ml-5 mt-5 block h-20 w-20 lg:h-16 lg:w-16"
        />
      ) : (
        <div className="lg:min-h-16 min-h-20 mt-5"></div>
      )}
      <div className="mt-8 min-h-[216px]">
        <div className="mb-2 px-5 pb-1 pt-2 font-title text-headings text-text-light">
          {card.brand}
        </div>
        <h2 className="px-5 font-title text-headingm text-text-default lg:text-headings xl:text-headingm">
          {card.name}
        </h2>
        {card && card?.typeOfOffer?.internalName !== 'regularOffer' && (
          <div
            className={`mt-3 px-5 font-title text-headingxs font-bold ${
              card?.typeOfOffer?.internalName === 'specialOffer'
                ? 'text-text-sticker-green'
                : 'text-text-sticker-blue'
            }`}
          >
            {card.typeOfOffer?.name}
          </div>
        )}
        <div className="px-5 pt-3 text-bodym text-neutral-grey-400">
          {dateRangeMedWithZoneOffset(
            card.validFrom,
            card.validTo,
            card.node_locale,
          )}
        </div>
        {card?.tags && (
          <div className="px-5 my-4 flex flex-wrap gap-2">
            {card?.tags?.map((tag, index) => {
              return (
                <span
                  key={index}
                  className="border-2 border-neutral-grey-300 py-1 px-2 rounded-md text-headingxxs text-neutral-grey-700 whitespace-nowrap"
                >
                  {tag}
                </span>
              );
            })}
          </div>
        )}
      </div>
      <div className='before:contents[""] after:contents[""] relative mt-6 flex items-center border-0 border-t-4 border-dotted border-t-brand-white py-10 pl-5 pr-8 before:absolute before:-left-3 before:-top-3.5 before:-z-10 before:block before:h-6 before:w-6 before:rounded-full before:bg-brand-white after:absolute after:-right-3 after:-top-3.5 after:-z-10 after:block after:h-6 after:w-6 after:rounded-full after:bg-brand-white xl:mt-10'>
        <div className="mr-2 font-title text-headings text-text-light lg:text-headingxs">
          {dictionary?.viewOffer}
        </div>
        <div className="ml-auto">
          <ChevronRightIcon className="h-3 w-3 text-text-sticker-blue" />
        </div>
      </div>
    </Link>
  );
};
